import { Text } from '@/components/Text/Text'

export function Strong({
    children,
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <Text tag="strong" size="inherit" weight="semibold">
            {children}
        </Text>
    )
}
